<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">授权视频</div>
    </div>
    <div class="page-body">
      <!-- 摄像头预览区域（全屏） -->
      <video
        ref="videoPlayer"
        autoplay
        muted
        playsinline
        class="camera-preview"
      ></video>
      <div class="djs" v-if="countdown">{{ countdown }}</div>
      <div class="lzsj" v-if="isRecording">{{ formattedTime }}</div>
      <!-- 控制按钮（可选） -->
      <div class="control-buttons" v-if="!showModal">
        <button
          v-if="!isRecording"
          @click="startRecording"
          class="btn"
        ></button>
        <button v-else @click="stopRecording" class="btnStop">
          <div></div>
        </button>
      </div>
    </div>
    <div class="topText">
      <div>
        我是 [保险代理人姓名]，所属 [保险公司 /
        保险中介机构名称]，执业证号或身份证号 [XXX]。
        我承诺：上传的个人形象视频属于我本人，真实合法，不含有低俗、违法及损害行业形象的信息；严格遵守保险行业监管规定及平台规则，自愿对视频内容承担全部法律责任
      </div>
    </div>
    <!-- 确认弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <!-- 弹窗内容（阻止冒泡） -->
      <div class="modal-content" @click.stop>
        <div class="modal-title">提示</div>
        <div class="modal-body">
          <div class="modal-text">
            请流畅朗读提示词的内容，录制定制数字人的形象授权视频，要保证人脸露出哦。
          </div>
        </div>
        <div class="modal-confirm-div">
          <div @click="handleConfirm" class="modal-confirm-btn">我知道了</div>
        </div>
      </div>
    </div>
    <!-- <loadingVue v-model="isLoading" text="文件上传中..." /> -->
  </div>
</template>

<script>
// import loadingVue from "@/components/loadingVue.vue";
import { voUpload, voDelete, convertWebmToMp4 } from "@/api";
import { Toast } from "vant";

export default {
  name: "authorizedVideo",
  // components: { loadingVue },
  data() {
    return {
      showModal: false,
      stream: null, // 摄像头媒体流
      mediaRecorder: null, // 录制器
      isRecording: false, // 是否正在录制
      recordedChunks: [], // 存储录制片段
      countdown: "", //  新增：倒计时数字
      countdownTimer: null, //  新增：定时器引用（用于清理）
      recordingTime: 0, // 录制经过的秒数
      recordingTimer: null, // 录制定时器
	  currentPlatform: '',
      // isLoading: false,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.recordingTime / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (this.recordingTime % 60).toString().padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
  },
  beforeDestroy() {
    this.cleanup();
    // 清除倒计时定时器（防内存泄漏）
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
    if (this.recordingTimer) {
      clearInterval(this.recordingTimer);
      this.recordingTimer = null;
    }
  },
  async mounted() {
	  document.title = "授权视频";
	  this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
    this.showModal = true;
  },
  methods: {
    // 返回按钮逻辑
    onBack() {
      this.$router.go(-1);
    },
    closeModal() {
      this.showModal = false;
      this.onBack();
    },
    async handleConfirm() {
      this.showModal = false;
      await this.startCamera();
    },
    startCamera() {
      navigator.mediaDevices
        .getUserMedia({
          video: { facingMode: "user" },
          audio: true,
        })
        .then((stream) => {
          this.stream = stream;
          this.$refs.videoPlayer.srcObject = stream;
          const mimeType = MediaRecorder.isTypeSupported("video/mp4") 
            ? "video/mp4"
            : MediaRecorder.isTypeSupported("video/webm")
            ? "video/webm"
            : "video/mp4";
          this.mediaRecorder = new MediaRecorder(stream, { mimeType });
          this.recordedChunks = [];
          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.recordedChunks.push(event.data);
            }
          };

          this.mediaRecorder.onstop = () => {
            this.handleUpload(); // 录制完成后上传
          };
        })
        .catch((err) => {
          this.$toast && this.$toast("请允许摄像头和麦克风权限");
          setTimeout(() => {
            this.onBack();
          }, 1000);
        });
    },

    // 👇 上传逻辑抽离为独立方法（这里可以用 async/await）
    async handleUploadTwice() {
      const mimeType = this.mediaRecorder.mimeType.includes("video/mp4")
        ? "video/mp4"
        : "video/webm";
      const blob = new Blob(this.recordedChunks, { type: mimeType });
      const extension = mimeType === "video/mp4" ? "mp4" : "webm";
      const videoFile = new File([blob], `recording.${extension}`, {
        type: mimeType,
        lastModified: Date.now(),
      });
      const formData = new FormData();
      formData.append("audioFile", videoFile);
      let data1 = await convertWebmToMp4(formData, { responseType: "blob" });
      const blob1 = new Blob([data1.data], { type: data1.data.type });
      const extension1 = "mp4";
      const videoFile1 = new File([blob1], `recording.${extension1}`, {
        type: "video/mp4",
        lastModified: Date.now(),
      });
      try {
        const formData1 = new FormData();
        formData1.append("audioFile", videoFile1);
        formData1.append("voType", "2");
        formData1.append("spot", "1");
        const data = await voUpload(formData1);
        if (data) {
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          const response = await fetch(data.fileUrl, {
            method: "PUT",
            mode: "cors",
            headers: {
              "Content-Type": "video/mp4",
            },
            body: videoFile1,
          });

          Toast.clear();

          if (response.ok) {
            this.$router.go(-1);
          } else {
            await voDelete(data.fileId);
            this.$toast && this.$toast("上传失败，请重试");
          }
        } else {
          this.$toast && this.$toast("上传初始化失败");
        }
      } catch (err) {
        Toast.clear();
        this.$toast && this.$toast("上传异常，请重试");
      }
    },
    async handleUpload() {
      const mimeType = this.mediaRecorder.mimeType.includes("video/mp4")
        ? "video/mp4"
        : "video/webm";
        if(mimeType=='video/webm'){
          return this.handleUploadTwice()
        }
      const blob = new Blob(this.recordedChunks, { type: mimeType });
      const extension = mimeType === "video/mp4" ? "mp4" : "webm";
      const videoFile = new File([blob], `recording.${extension}`, {
        type: mimeType,
        lastModified: Date.now(),
      });
      const formData = new FormData();
      formData.append("audioFile", videoFile);
      formData.append("voType", "2");
      formData.append("spot", "1");

      try {
        const data = await voUpload(formData);
        if (data) {
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          const response = await fetch(data.fileUrl, {
            method: "PUT",
            mode: "cors",
            headers: {
              "Content-Type": "video/mp4",
            },
            body: videoFile,
          });

          Toast.clear();

          if (response.ok) {
            this.$router.go(-1);
          } else {
            await voDelete(data.fileId);
            this.$toast && this.$toast("上传失败，请重试");
          }
        } else {
          this.$toast && this.$toast("上传初始化失败");
        }
      } catch (err) {
        Toast.clear();
        this.$toast && this.$toast("上传异常，请重试");
      }
    },
    // 开始录制（带倒计时）
    startRecording() {
      if (this.isRecording || this.countdown || !this.mediaRecorder) return;

      const steps = [3, 2, 1, "开始"];
      let index = 0;

      this.countdown = String(steps[index]); // 显示 "3"

      this.countdownTimer = setInterval(() => {
        index++;
        if (index < steps.length - 1) {
          // 还在数字阶段：2, 1
          this.countdown = String(steps[index]);
        } else if (index === steps.length - 1) {
          // 显示“开始录制”
          this.countdown = "开始";
        } else {
          // 倒计时和提示结束，开始录制
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
          this.countdown = ""; // 清空提示
          this.mediaRecorder.start();
          this.isRecording = true;
          // 在 this.mediaRecorder.start(); 之后
          this.recordingTime = 0;
          this.recordingTimer = setInterval(() => {
            this.recordingTime++;
          }, 1000);
        }
      }, 1000);
    },
    // 停止录制
    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;

        // 清除录制计时器
        if (this.recordingTimer) {
          clearInterval(this.recordingTimer);
          this.recordingTimer = null;
        }
        // 可选：停止后返回或上传
        // this.uploadVideo();
      }
    },

    // 清理资源
    cleanup() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
      }
      if (this.mediaRecorder) {
        this.mediaRecorder = null;
      }
    },
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* 弹窗内容 */
.modal-content {
  width: 80vw;
  /* height: 58.666vw; */
  border-radius: 3.2vw;
  background-color: #ffffff;
}

.modal-title {
  line-height: 6.2666vw;
  color: #666666;
  font-weight: 500;
  font-size: 4.2666vw;
  text-align: center;
  padding: 5.333vw 0 4.2666vw 0;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 6.4vw;
}
.modal-text {
  /* min-width: 44.8vw; */
  color: #666666;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 1.0666vw;
  text-align: center;
}

.modal-confirm-div {
  display: flex;
  justify-content: center;
  padding-bottom: 5.333vw;
}
.modal-confirm-btn {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  line-height: 10.666vw;
  text-align: center;
  opacity: 0.8;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
  margin-top: 5.4666vw;
}
.topText {
  width: 91.466vw;
  height: 40.2666vw;
  border-radius: 2.1333vw;
  /* opacity: 0.4; */
  background-color: #3d3530;
  position: fixed;
  top: 18.666vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 3.7333vw;
  line-height: 5.466vw;
  left: 50%;
  transform: translate(-50%, 0%);
  z-index: 5;
}
.topText > div {
  padding: 3.7333vw;
}

/* 全屏视频预览 */
.camera-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  object-fit: cover; /* 保持比例并铺满 */
  z-index: 1;
  transform: scaleX(-1); /* 镜像（自拍效果）*/
}

/* 控制按钮 */
.control-buttons {
  position: fixed;
  bottom: 13.333vw;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.btn {
  width: 18.666vw;
  height: 18.666vw;
  background-color: #ff1b00;
  border: 1.0666vw solid #ffffff;
  border-radius: 50%;
}
.btnStop {
  width: 18.666vw;
  height: 18.666vw;
  background-color: transparent;
  border: 1.0666vw solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnStop > div {
  width: 6.666vw;
  height: 6.666vw;
  border-radius: 0.2666vw;
  background-color: #ff1b00;
}
/* 倒计时数字 */
.djs {
  position: fixed;
  bottom: 48vw;
  left: 50%;
  transform: translate(-50%);
  color: #e6e1e0;
  font-weight: 700;
  font-size: 13.333vw;
  z-index: 8;
  pointer-events: none; /* 不阻挡点击 */
}
.lzsj {
  position: fixed;
  bottom: 37.333vw;
  left: 50%;
  transform: translate(-50%);
  z-index: 9;

  width: 17.2vw;
  height: 8.5333vw;
  border-radius: 6.1333vw;
  background-color: #1f222640;
  color: #ffffff;
  font-weight: 500;
  font-size: 3.7333vw;
  text-align: center;
  line-height: 8.5333vw;
}
</style>
